import React from 'react';
import {
  StyledBoosterNavigationButton,
  StyledBoosterNavigationButtonDisabled,
  StyledBoosterNavigationButtonOutlined,
} from './styled.boosterNavigationButton';
import { IButton } from './../../../../@types/button';
import { Loading } from './../../../icons/Loading';
import { Headline4 } from '../../../../../app/common/typography';

export function BoosterNavigationButton ({
  title,
  onClick,
  outlined,
  backgroundColor,
  inverted,
  disabled,
  loading,
  textColor,
  rounded,
  leftIcon,
  rightIcon,
}: IButton) {
  // title -> text inside the button
  // onClick -> function sent to parent
  // outlined -> if the button has outlined, the value must be TRUE (by default FALSE / 1px withe)
  // backgroundColor -> button color (follow the color in theme/default.ts)
  // inverted -> variable to invert the colors, this means, backgroundColor becomes outlineColor and backgroundColor becomes withe
  // disabled -> should be TRUE if the button is disabled

  if (disabled) {
    return (
      <StyledBoosterNavigationButtonDisabled rounded={rounded}>
        {leftIcon || <span />}
        <Headline4 color="white" fontWeight="semiBold">{title}</Headline4>
        {rightIcon || <span />}
      </StyledBoosterNavigationButtonDisabled>
    );
  }

  if (outlined) {
    return (
      <StyledBoosterNavigationButtonOutlined
        onClick={onClick}
        inverted={inverted}
        backgroundColor={backgroundColor}
        disabled={loading}
        textColor={textColor}
        rounded={rounded}
        loading={loading}
      >
        {loading ? (
          <Loading color={backgroundColor} size="m" />
        ) : (
          <>
            {leftIcon || <span />}
            <Headline4
              color={inverted ? backgroundColor : textColor || 'white'}
              fontWeight="semiBold"
            >
              {title}
            </Headline4>
            {rightIcon || <span />}
          </>
        )}
      </StyledBoosterNavigationButtonOutlined>
    );
  }

  return (
    <StyledBoosterNavigationButton
      onClick={onClick}
      backgroundColor={backgroundColor}
      disabled={loading}
      rounded={rounded}
      textColor={textColor}
      loading={loading}
    >
      {loading ? (
        <Loading size="m" />
      ) : (
        <>
          {leftIcon || <span />}
          <Headline4 color={textColor || 'white'} fontWeight="semiBold">{title}</Headline4>
          {rightIcon || <span />}
        </>
      )}
    </StyledBoosterNavigationButton>
  );
}
